<app-login-header></app-login-header>

<nes-container data-pw="login" class="nes-flex-col nes-w-full nes-mx-auto nes-pt-6 md:nes-pt-10">
  <mnz-messageStoreConnector></mnz-messageStoreConnector>

  <div @fadeIn class="nes-flex-col nes-pt-6 md:nes-pt-10">
    <div class="nes-mb-8">
      <nes-link data-pw="login__back-link" icon="arrow-left" stand-alone (click)="backToOverview()" relay42>
        {{ 'LOGIN.BACK_TO_OVERVIEW' | translate }}
      </nes-link>
    </div>

    <nes-heading class="nes-mb-8" [size]="{xs:'5xl', md:'6xl'}">
      {{ ('LOGIN.AUTH.TITLE' | translate) + " " }} {{((accountType$ | async) === "contactpersoon" ? "CONTACT_PERSON" :
      "CARD_HOLDER") | translate }}
    </nes-heading>

    <mnz-login-form></mnz-login-form>

    <div class="nes-w-full md:nes-w-6/12">
      <mnz-customer-requirements></mnz-customer-requirements>
    </div>
  </div>
</nes-container>
